export class AnimationTimeoutId {}

/**
 * Collection of static methods used for timers.
 */
export class TimerUtils {
  /**
   * A little wrapper around setTimeout, to clearly indicate that
   * it's role is thought of as a hacky workaround vs a principled design.
   */
  static callLater_HACK(fun, timeoutMsecs = 0) {
    setTimeout(fun, timeoutMsecs);
  }

  /**
   * Sets a timeout callback using requestAnimationTimeout.
   * Uses requestAnimationFrame() under the covers which allegedly results in better performance.
   * @param {Function} callback Callback function with no args
   * @param {number} delay Delay in msec.
   * @returns {AnimationTimeoutId} ID for the timer which can be used in call to cancelAnimationTimerout().
   */
  static requestAnimationTimeout(callback, delay) {
    const start = Date.now();
    const frame = new AnimationTimeoutId();
    frame.id = window.requestAnimationFrame(internalCallback);
    return frame;
    function internalCallback(timestamp) {
      if (Date.now() - start >= delay) {
        callback();
      } else {
        // try again
        frame.id = window.requestAnimationFrame(internalCallback);
      }
    }
  }

  /**
   * Cancel a timer set using requestAnimationTimeout().
   * @param {AnimationTimeoutId} id ID returned from call to requestAnimationTimeout()
   */
  static cancelAnimationTimeout(id) {
    window.cancelAnimationFrame(id.id);
  }

  /**
   * Wait for the specified number of milliseconds
   * @param ms number of milliseconds to wait
   */
  static wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
//# sourceMappingURL=TimerUtils.js.map
